exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay[data-v-b43b6b72]{height:100vh;top:0;left:0;background-color:rgba(0,0,0,0.4);z-index:4}\n", ""]);

// exports
